// FreteDoLivro.js — o CEP e as modalidades de entrega do livro impresso.
//
// SÓ DESENHA. Todo o estado (e a regra de quando o frete vale) mora em
// useFreteDoLivro.js — ver o cabeçalho de lá para o porquê de ele ter saído de
// dentro do cartão de preço.
//
// DUAS ROUPAS, porque ele aparece em dois lugares:
//
//   `solto`  (computador, embaixo da capa) — precisa de moldura e de TÍTULO:
//            ali fora, sem o cartão de preço em volta, um campo de CEP solto
//            não diz a que livro nem a que formato se refere.
//   sem ele  (celular, dentro do cartão) — continua como sempre foi: o cartão
//            em volta já dá o contexto, e uma moldura dentro de outra só
//            apertaria a coluna.
import React from "react";

export default function FreteDoLivro({ frete, solto = false, className = "" }) {
  const campo = (
    <>
      <div className="flex items-center gap-2 rounded-controle border border-line px-2 py-1">
        {/* Editável, sempre: o CEP do perfil é um ponto de partida, não uma
            escolha feita pela pessoa. Com máscara, e as opções de frete somem
            se o CEP deixar de ter 8 dígitos — elas não podem ficar abertas
            para um CEP pela metade. */}
        <input
          value={frete.cep}
          onChange={(e) => frete.digitarCep(e.target.value)}
          placeholder="Insira seu CEP"
          inputMode="numeric"
          aria-label="CEP para calcular o frete"
          className="flex-1 bg-transparent px-2 py-1.5 text-sm text-white placeholder:text-white/40 outline-none"
        />
        <button
          type="button"
          onClick={frete.calcular}
          className="foco-laranja rounded-controle px-3 text-sm font-semibold text-insigne-orange hover:underline"
        >
          Calcular
        </button>
      </div>

      {frete.erro && <p className="mt-2 text-xs text-red-300">{frete.erro}</p>}

      {frete.mostrar && (
        <div className="mt-2 space-y-1.5 text-sm">
          <p className="rounded-selo bg-amber-400/10 px-2 py-1 text-xs text-amber-300">
            O frete final é calculado no carrinho pelo total de livros físicos.
          </p>
          {["20", "70"].map((chave) => {
            const m = frete.modalidades[chave];
            return (
              <label key={chave} className="flex items-center gap-2 text-white/80">
                <input
                  type="radio"
                  name="frete"
                  checked={frete.selecionada === chave}
                  onChange={() => frete.escolher(chave)}
                  className="accent-insigne-orange"
                />
                {m.rotulo}: R$ {m.valor},00/pacote
              </label>
            );
          })}
        </div>
      )}
    </>
  );

  if (!solto) return <div className={className}>{campo}</div>;

  return (
    <section className={"bloco p-[1.125rem] " + className} aria-label="Frete do livro impresso">
      <p className="flex items-center gap-2 text-sm font-bold text-white">
        <i className="bi bi-truck text-insigne-orange" aria-hidden="true" />
        Frete do impresso
      </p>
      <p className="mb-3 mt-1 text-xs leading-relaxed text-white/50">
        Informe o CEP para ver os prazos. O e-book, quando o título tem os dois
        formatos, não tem frete.
      </p>
      {campo}
    </section>
  );
}
